import { CapoPlugin } from "/home/runner/work/famitei.co.jp-web2/famitei.co.jp-web2/web/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];